import React, { FC } from "react";

export const BreadCrumbsContainer: FC = () => {
  return <div id={"breadcrumbs-portal"} />;
};
